import Vue from 'vue'
import App from './App.vue'
import router from '@/router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import store from '@/store';
import VueMeta from 'vue-meta';
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import 'github-markdown-css/github-markdown.css'
import hljs from "highlight.js";
import { fetchToken } from './api';
import { ACCESS_TYPE } from '@/constants';
Vue.prototype.$hljs = hljs;
// 有多种样式可选，也可以到对应文件中定制化
import "highlight.js/styles/atom-one-dark.css";
// 自定义命令v-highlight
Vue.directive("highlight", function (el) {
  let blocks = el.querySelectorAll("pre code");
  blocks.forEach(block => {
    hljs.highlightBlock(block);
  });
});
//复制组件引用
import clipboard from 'clipboard'
Vue.prototype.clipboard = clipboard;


iziToast.settings({
  'timeout': 3000,
  'backgroundColor': '#ffffff40',
  'titleColor': '#efefef',
  'messageColor': '#efefef',
  'progressBar': ![],
  'close': ![],
  'closeOnEscape': !![],
  'position': 'topCenter',
  'transitionIn': 'bounceInDown',
  'transitionOut': 'flipOutX',
  'displayMode': 'replace',
  'layout': '1'
});

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
  writable: false,
  enumerable: false,
  configurable: false,
  value: 2
});

let tokenGet = webIMType.map(type => {
  return new Promise(async (resolve, reject) => {
    let demoToken = '';
    if (ACCESS_TYPE === 'ws') {
      const { token } = (await fetchToken()).data;
      console.log(token)
      demoToken = token;
    }
    let result = {
      type: type,
      token: demoToken,
      access: ACCESS_TYPE
    };
    console.log('【init msg----------demoToken---->】', result);
    resolve(result);
  });
});

Promise.all(tokenGet).then(res => {
  Object.defineProperty(window, 'webimToken', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: res
  });
  (async () => {
    let mixin = await import('@/manage/index');
    Vue.mixin(mixin);
    Vue.config.productionTip = false;
    Vue.config.devtools = true;
    Vue.use(ElementUI);
    Vue.use(VueMeta);
    Vue.use(iziToast);
    console.log(Vue.prototype.$eventHub)
    console.log(Vue.prototype.$socket)
    // VMdPreviewHtml.use(vuepressTheme, {
    //   Hljs: hljs
    // });
    new Vue({
      el: '#app',
      render: h => h(App),
      router,
      store
    }).$mount('#app')

  })();
});



